/**
 * `/itineraries/new` — create a fresh itinerary then hand off to its editor.
 * Title-first: a single field + top-right Create button (repo form rule),
 * then `trpc.itinerary.create` → navigate to `/itineraries/<slug>/edit`.
 */

import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { trpc } from '../lib/trpc';
import { PageContainer } from '../components/PageContainer';
import { Heading1, Caption } from '../components/ui/Typography';
import { Button } from '../components/ui/Button';

export const ItineraryNewPage = () => {
  const navigate = useNavigate();
  const utils = trpc.useUtils();
  const [title, setTitle] = useState('');

  const create = trpc.itinerary.create.useMutation({
    onSuccess: (created) => {
      utils.itinerary.listMine.invalidate();
      navigate(`/itineraries/${created.publicSlug}/edit`);
    },
  });

  const valid = title.trim().length > 0;

  return (
    <div className="px-0 md:px-4 pt-2 pb-4">
      <PageContainer className="mt-2">
        <div className="border-b border-[#DBD4C9] pb-4">
          <div className="mb-4 flex justify-end gap-3">
            <Button
              variant="primary"
              disabled={!valid || create.isPending}
              loading={create.isPending}
              onClick={() => create.mutate({ title: title.trim(), regionRefs: [] })}
            >
              Create
            </Button>
            <Button variant="outline" onClick={() => navigate('/itineraries')}>
              Cancel
            </Button>
          </div>
          <Heading1>New itinerary</Heading1>
          {create.isError && (
            <Caption className="mt-2 block text-error">
              Couldn&apos;t create the itinerary. Try again.
            </Caption>
          )}
        </div>

        <div className="mt-4">
          <input
            type="text"
            autoFocus
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            placeholder="Itinerary title (e.g. Sonoma long weekend)"
            className={`w-full rounded-lg border bg-gray-50 px-3 py-2 text-gray-900 focus:outline-none focus:ring-2 focus:ring-info-500 ${
              valid ? 'border-success-500' : 'border-[#DBD4C9]'
            }`}
          />
        </div>
      </PageContainer>
    </div>
  );
};
